// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__NapGO","btnPagination":"styles_btnPagination__yx5zr"};